const search = document.querySelector('.js-search');

function openLogin(elem) {
    search.classList.add('active');
    document.body.classList.add("search-open");

    if(login && login.classList) {
      login.classList.remove('active');
    }
    document.body.classList.remove("login-open");

    menu.classList.remove('active');
    document.body.classList.remove("menu-open");
}

function toggleLogin(elem) {
    search.classList.toggle('active');
    document.body.classList.toggle("search-open");

    if(login && login.classList) {
      login.classList.remove('active');
    }
    document.body.classList.remove("login-open");

    menu.classList.remove('active');
    document.body.classList.remove("menu-open");
}

var toggle = document.querySelectorAll('.js-toggle-search');
for (var i = 0; i < toggle.length; i++) {
    toggle[i].addEventListener('click', toggleLogin, false);
}
